module.exports = __webpack_public_path__ + "img/logo-incantalia.360c43e6.jpg";